import React from "react";

const TipItem = ({ tip }) => (
  <div className="p-4 flex justify-between items-center">
    <div>
      <p className="text-sm text-slate-500">You tipped</p>
      <p className="font-bold text-slate-800">{tip.creatorName}</p>
      <p className="text-xs text-slate-400 mt-1">{tip.date}</p>
    </div>
    <p className="font-semibold text-primary text-lg">{tip.amountETB} ETB</p>
  </div>
);

export default TipItem;
